import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TokenGate } from "../features/auth/TokenGate";
import { Shell } from "./layout/Shell";
import { useAppStore } from "@/lib/store";
import { ErrorBoundary } from "./ErrorBoundary";
import { useEffect } from "react";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function AppContent() {
  const apiToken = useAppStore((state) => state.apiToken);
  const initializeFromUrl = useAppStore((state) => state.initializeFromUrl);

  // Initialize from URL on mount
  useEffect(() => {
    initializeFromUrl();
  }, [initializeFromUrl]);

  if (!apiToken) {
    return <TokenGate />;
  }

  return <Shell />;
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <AppContent />
      </ErrorBoundary>
    </QueryClientProvider>
  );
}

